<template>
  <i class="licenses-info" v-tooltip="info" v-if="info">
    <img src="@/assets/img/icons/info.svg" alt="Info">
  </i>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'LicenseInfo',
  props: {
    info: { type: String, default: '' },
  },
});
</script>

<style scoped>
i.licenses-info {
  display: flex;
  justify-content: center;
  align-items: center;

  position: relative;
  width: 1rem;
  height: 1rem;
  flex-shrink: 0;

  mask-image: url("@/assets/img/icons/ellipse3.svg");
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
  -webkit-mask-image: url("@/assets/img/icons/ellipse3.svg");
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  -webkit-mask-size: contain;

  background-color: var(--grey-deep, #252525);
}
</style>
